import { call, put, takeLatest } from "redux-saga/effects";
import { bsktDotHocApi } from "../../../api/category/bsktDotHocApi";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { rootActions } from "../../actions/rootActions";
import { eBSKTDotHocActionIds } from "../../action-types/category/IBSKTDotHocActions";

export function* bsktDotHocSaga(): any {
  yield takeLatest(eBSKTDotHocActionIds.LOAD_START, loadWorker);
}

function* loadWorker(): any {
  const res: IBaseRespone = yield call(bsktDotHocApi.SelectAll);
  if (res.is_success) {
    yield put(rootActions.category.bsktDotHoc.LOAD_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.category.bsktDotHoc.LOAD_ERRR(res.message ?? "Có lỗi"),
    );
  }
}
